import { ChangePartner } from './ChangePartner';

export class ChangePartnerTitle extends ChangePartner {
  type: string = 'Partner.ChangeTitle';
}
